import { Settings } from 'constants/settings';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { AccountSetting } from 'types/domain';

interface AggregatedAccountSettings {
    settings: AccountSetting[];
    googleAnalytics: AccountSetting | undefined;
    facebookPixel: AccountSetting | undefined;
    customSubscription: AccountSetting | undefined;
}

const useCurrentAccountSettings = () => {
    const { settings } = useCurrentAccount();

    return aggregateIndividualSettings(settings);
};

const aggregateIndividualSettings = (settings: AccountSetting[]): AggregatedAccountSettings => {
    const getValueByCode = (code: number) => settings.find(item => item.code === code);

    return {
        settings: settings,
        googleAnalytics: getValueByCode(Settings.GoogleAnalytics.Code),
        facebookPixel: getValueByCode(Settings.FacebookPixel.Code),
        customSubscription: getValueByCode(Settings.CustomSubscription.Code),
    };
};

export { useCurrentAccountSettings };
